import Box from "@mui/material/Box";
import "./index.scss";

const DeleteConfirm = ({ data, deleteLayer, cancel }) => {
    return (
        <Box className="delete-layer-wrapper">
            <Box className="top-box">
                Delete "{data?.title}"?
            </Box>
            <Box className="actions">
                <button className="cancel" onClick={cancel}>Cancel</button>
                <button className="delete" onClick={deleteLayer}>Delete</button>
            </Box>
            
        </Box>
    )
}

export default DeleteConfirm